import React from 'react'
import styled from '@emotion/styled'
import { object, string } from 'prop-types'

import { TemplateWrapper } from './TemplateWrapper'
import { RfqWidget } from '@jelly/components'

const WidgetWrapper = styled.div`
	margin: 0rem auto 4rem;
	min-height: 650px;
	max-width: 640px;
	width: 90%;

	.bzWidget {
		border-radius: 18px;
		box-shadow: ${({ theme }) => theme.shadows.greyMedium};
	}

	${({ theme }) => theme.MQ.M} {
		margin: 0rem auto 8rem;
		width: 100%;
	}
`

LeaveBehindForm.propTypes = {
	meta: object,
	widgetCategoryId: string.isRequired,
}
/**
 * Template for the Leave Behind Form that pops up in a new tab
 *
 * @param {Object} props.meta :: data for meta data
 * @param {String} props.widgetCategoryId :: id to determine the widget
 */
export function LeaveBehindForm({ meta, widgetCategoryId }) {
	return (
		<TemplateWrapper meta={meta}>
			<WidgetWrapper>
				{/* the default publisher id is for testing on staging */}
				<RfqWidget
					publisherId={process.env.GATSBY_WIDGET_ENV === 'PROD' ? '57290' : '203428'}
					widgetCategoryId={widgetCategoryId}
				/>
			</WidgetWrapper>
		</TemplateWrapper>
	)
}
